export default "<p>campaigns works!</p>\n"